import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '分类浏览', path: '/category' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-link-m text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-xl font-bold transition-colors duration-300 ${
              isScrolled ? 'text-foreground-900' : 'text-background-50'
            }`}>
              {siteInfo.name}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`whitespace-nowrap text-sm font-medium transition-all duration-200 relative py-1 ${
                    isScrolled
                      ? isActive
                        ? 'text-primary-600'
                        : 'text-foreground-700 hover:text-primary-600'
                      : isActive
                        ? 'text-background-50'
                        : 'text-background-50/80 hover:text-background-50'
                  }`}
                >
                  {link.label}
                  {isActive && (
                    <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-500 rounded-full" />
                  )}
                </Link>
              );
            })}
            <a
              href={siteInfo.officialUrl}
              className="whitespace-nowrap bg-primary-500 text-background-50 px-5 py-2 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即访问
            </a>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md transition-colors ${
              isScrolled ? 'text-foreground-700' : 'text-background-50'
            }`}
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-2">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`block px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-50 text-primary-600'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <a
              href={siteInfo.officialUrl}
              className="block text-center bg-primary-500 text-background-50 px-5 py-2.5 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即访问
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}